export default {
  // money_host: 'http://money-test.fanink.cn',
  // pay_host: 'http://pay-api-test.fanink.cn',
  // movie_host: 'http://172.16.222.77:3000'
  movie_host: 'http://qmovie.fanink.cn'
}
